export default () => {
  return 'https://ark-api.proof-point-suite.com'
}
